import { Navigate, useLocation } from "react-router";
import type { AppRouteObject } from "./types";
import { lazyRoute } from "./lazyRoute";
import { FontAwesomeIcons } from "src/constants/fontAwesomeIcons";
import * as Dtos from "src/dtos/Tmd.dtos";

function DashboardRedirect() {
    const { search, hash } = useLocation();
    return <Navigate replace to={{ pathname: "/dashboard", search, hash }} />;
}

export const coreRoutes: AppRouteObject[] = [
    {
        index: true,
        element: <DashboardRedirect />,
        handle: { help: null }
    },
    {
        path: "*",
        element: <Navigate replace to="/error/404" />,
        handle: { help: null }
    },
    {
        path: "dashboard",
        lazy: lazyRoute(() => import("../containers/Dashboard/DashboardPage")),
        handle: {
            title: "Dashboard",
            help: { topicKey: "dashboard" },
            breadcrumb: { label: "Dashboard", icon: FontAwesomeIcons.Duotone.HOME, url: "/dashboard" },
            navigation: { title: "Dashboard", icon: FontAwesomeIcons.Duotone.HOME, primary: true, drawer: true, order: 0 },
            access: { anyMatchPermission: Dtos.Permission.DashboardView },
        }
    },
    {
        path: "dashboard-preview",
        lazy: lazyRoute(() => import("../containers/Dashboard/DashboardPreviewPage")),
        handle: {
            title: "Dashboard Preview",
            help: { topicKey: "dashboard" },
            breadcrumb: { label: "Dashboard Preview", icon: FontAwesomeIcons.Duotone.HOME, url: "/dashboard-preview" },
            access: { anyMatchPermission: Dtos.Permission.DashboardView },
        }
    },
    {
        path: "my-trial-institutions",
        lazy: lazyRoute(() => import("../containers/Dashboard/DashboardPage")),
        handle: {
            title: "My Trial Institutions",
            help: { topicKey: "dashboard" },
            breadcrumb: { label: "My Trial Institutions", icon: FontAwesomeIcons.Duotone.HOME, url: "/my-trial-institutions" },
            access: { anyMatchPermission: Dtos.Permission.TrialInstitutionView },
        }
    },
    {
        path: "search",
        lazy: lazyRoute(() => import("../containers/Search/SearchPage")),
        handle: {
            title: "Search",
            help: { topicKey: "search" },
            breadcrumb: { label: "Search", icon: FontAwesomeIcons.Duotone.SEARCH, url: "/search" },
            navigation: { title: "Search", icon: FontAwesomeIcons.Duotone.SEARCH, primary: true, drawer: true, order: 9 },
        }
    },
    {
        path: "mytrials",
        lazy: lazyRoute(() => import("../containers/MyTrials/MyTrials/MyTrialsPage")),
        handle: {
            title: "My Trials",
            help: { topicKey: "my-trials" },
            breadcrumb: { label: "My Trials", icon: FontAwesomeIcons.Duotone.TRIAL, url: "/mytrials" },
            access: { anyMatchPermission: Dtos.Permission.TrialView },
        }
    },
    {
        path: "error",
        handle: { help: null },
        children: [
            {
                path: ":errorCode",
                lazy: lazyRoute(() => import("../containers/Error/errorPage")),
                handle: { help: { topicKey: "error" } }
            },
        ],
    }
] satisfies AppRouteObject[];

